<script lang="ts">
  import { afterNavigate } from '$app/navigation';
  import { faChevronLeft } from '@itdev-fortawesome/pro-solid-svg-icons/faChevronLeft';
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';

  let previousPage: string | null = $state(null);

  afterNavigate(({ from }) => {
    previousPage = from?.url.pathname ?? null;
  });
</script>

<nav class="mb-3 small">
  <a
    href={previousPage}
    onclick={e => {
      e.preventDefault();
      window.history.back();
    }}
  >
    <FontAwesomeIcon icon={faChevronLeft} class="me-1" />Back
  </a>
</nav>
